export class AnalyticalMethod {
    id: string;
    methodName: string;
    agency: string;
    instrumentation: string;
    description: string;
    url: string;
    sampleMediaIds?: string[]
}